import { atom } from '@reatom/framework'

import type { LimitOrder } from '@root/entities/limit-order'

export type OrdersPageTab = 'orders' | 'tokens'
export type OrdersPageSideFilter = 'all' | 'buy' | 'sell'

export const ordersPageTabAtom = atom<OrdersPageTab>(
  'orders',
  'ordersPageTabAtom',
)

export const ordersPageSideFilterAtom = atom<OrdersPageSideFilter>(
  'all',
  'ordersPageSideFilterAtom',
)

export const ordersPageStatusAtom = atom<LimitOrder.Status>(
  'active',
  'ordersPageStatusAtom',
)
